"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlFontSizeAdjust = exports.htmlFontSize = exports.fontWeightRegular = exports.fontWeightMedium = exports.fontWeightLight = exports.fontWeightBold = exports.fontFamilyCondensed = exports.fontFamily = void 0;
const fontFamily = exports.fontFamily = 'SansOri, SansOriFallback, sans-serif';
const fontFamilyCondensed = exports.fontFamilyCondensed = 'SansCondensedOri, SansCondensedOriFallback, sans-serif';
const fontWeightLight = exports.fontWeightLight = 400;
const fontWeightRegular = exports.fontWeightRegular = 400;
const fontWeightMedium = exports.fontWeightMedium = 700;
const fontWeightBold = exports.fontWeightBold = 700;
const htmlFontSize = exports.htmlFontSize = 10;
const htmlFontSizeAdjust = exports.htmlFontSizeAdjust = '63%';
